import React from 'react';
import { Icon } from './Icon';

/** Compact frosted native <select>. Ported from D:\campaigning-system\src\components\ui\FilterSelect.tsx. */
export function FilterSelect({ label, value, options, onChange, icon, className = '' }) {
  const active = value !== 'All';
  return (
    <div className={`relative ${className}`}>
      {icon && (
        <Icon name={icon} className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-[18px] text-cos-ink-muted" />
      )}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={label}
        className={[
          'h-10 w-full cursor-pointer appearance-none rounded-xl border bg-white/60 pr-9 text-sm font-medium text-cos-ink transition-all duration-200 focus:border-cos-teal focus:shadow-cos-teal-glow focus:outline-none',
          icon ? 'pl-9' : 'pl-3',
          active ? 'border-cos-teal/40 bg-cos-teal-faint/50 text-cos-teal-deep' : 'border-cos-line',
        ].join(' ')}
      >
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {label && opt === 'All' ? `${label}: All` : opt}
          </option>
        ))}
      </select>
      <Icon name="expand_more" className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-[18px] text-cos-ink-muted" />
    </div>
  );
}

export default FilterSelect;
